import { object } from "yup"
import { password, confirmPassword } from "@/core/validation"

export default object({
  password,
  confirmPassword,
})
